// src/components/salon-management/staff-section/StaffCard.tsx
import React from "react";
import { Card, CardContent, Tooltip, Avatar } from "@mui/material";
import { Phone as PhoneIcon } from "@mui/icons-material";
import { StylingStaff } from "../../../types/salon.types";
import Image from "src/shared/Image";
import { useUserTheme } from "src/shared/hooks/useUserTheme";

interface StaffCardProps {
  staff: StylingStaff;
  onClick: () => void;
}

const StaffCard: React.FC<StaffCardProps> = ({ staff, onClick }) => {
  const { bgClass } = useUserTheme();

  const staffName = `${staff.firstName ?? ""} ${staff.middleName ?? ""} ${staff.lastName ?? ""}`.trim().toLowerCase();

  return (
    <Card
      onClick={onClick}
      role='button'
      tabIndex={0}
      className='
        cursor-pointer outline-none
        bg-white h-full flex flex-col
        rounded-xl overflow-hidden
        shadow-sm min-h-[140px]
        transition-all duration-300 ease-in-out
        hover:-translate-y-0.5 hover:shadow-lg
        focus-visible:ring-2 focus-visible:ring-blue-600
      '
    >
      <CardContent className='flex flex-col flex-1 p-2 last:pb-3'>
        {/* Avatar + Name */}

        <div className='flex items-center gap-3 mb-1'>
          <Avatar className='w-12 h-12 sm:w-13 sm:h-13 md:w-14 md:h-14 bg-blue-600 flex-shrink-0'>
            <Image imagePath={staff.staffImageKey} className={`w-full h-full object-cover  ${bgClass}`} profile={true} />
          </Avatar>

          <Tooltip title={staff.firstName} arrow>
            <h3 className='font-semibold text-gray-900 text-[0.95rem] sm:text-[1.05rem] md:text-[1.15rem] leading-tight line-clamp-2'>{staffName}</h3>
          </Tooltip>
        </div>

        {/* Phone */}
        {staff.phones && (
          <div
            className='
            mt-auto flex items-center gap-2
            p-2 rounded-lg
            bg-blue-50 border border-blue-100
            min-h-[40px]
          '
          >
            <PhoneIcon className='text-blue-600 text-sm flex-shrink-0' />
            <p
              className='
              text-gray-600 font-medium
              text-[0.8rem] md:text-[0.85rem]
              leading-snug line-clamp-2 break-all
            '
            >
              {staff.phones.map((i) => i.phone)}
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default StaffCard;
